<template lang='pug'>
div.vendor-permissions-component
  //Notification Alert
  Notificationalert(
    v-if="controls.alert.display" 
    v-bind:alert="controls.alert"
  )

  .tw-flex.tw-flex-row.tw-justify-between.tw-items-center.tw-mb-3
    div
      h5.h5.tw-text-gray-500
        i.fa-solid.fa-shield-halved.tw-mr-2
        | {{$I18n.t('vue.vendor_permissions.title')}}
    div(v-if="state.loading" class="tw-text-center")
      div(class="spinner-border spinner-border-sm" role="status")

  .tw-bg-gray-50.tw-rounded.tw-p-3.tw-mb-3(v-if="!state.loading")
    p.tw-text-sm.tw-text-gray-600.tw-mb-0
      i.fa-solid.fa-info-circle.tw-mr-1
      | {{$I18n.t('vue.vendor_permissions.description')}}

  //- Sin asignaciones = acceso total
  div(v-if="!state.loading && assignedVendors.length === 0")
    .tw-flex.tw-items-center.tw-p-3.tw-bg-green-50.tw-rounded.tw-border.tw-border-green-200.tw-mb-3
      i.fa-solid.fa-globe.tw-text-green-600.tw-mr-2
      span.tw-text-green-800 {{$I18n.t('vue.vendor_permissions.unrestricted')}}

  //- Lista de vendors asignados
  div(v-if="!state.loading && assignedVendors.length > 0")
    .tw-mb-2
      span.tw-text-sm.tw-font-semibold.tw-text-gray-700 {{$I18n.t('vue.vendor_permissions.assigned_vendors')}}:
    .tw-flex.tw-flex-wrap.tw-gap-2.tw-mb-3
      .tw-inline-flex.tw-items-center.tw-bg-blue-100.tw-text-blue-800.tw-rounded-full.tw-px-3.tw-py-1(
        v-for="vendor in assignedVendors" 
        :key="vendor.id"
      )
        span.tw-text-sm {{ vendor.vendor_name }}
        button.tw-ml-2.tw-text-blue-600.tw-hover-text-blue-800(
          @click="removeAssignment(vendor.id)"
          :disabled="state.saving"
          :title="$I18n.t('vue.vendor_permissions.remove')"
        )
          i.fa-solid.fa-times-circle

  //- Agregar vendor
  div(v-if="!state.loading")
    .tw-flex.tw-flex-row.tw-gap-2.tw-items-end
      div.tw-flex-grow
        label.tw-text-sm.tw-font-medium.tw-text-gray-700.tw-mb-1(for="vendor-select")
          | {{$I18n.t('vue.vendor_permissions.add_vendor')}}
        select#vendor-select.form-select.form-select-sm(v-model="selectedVendorId")
          option(value="" disabled) {{$I18n.t('vue.vendor_permissions.select_vendor')}}
          option(
            v-for="vendor in availableVendors" 
            :key="vendor.id" 
            :value="vendor.id"
          ) {{ vendor.name }}
      div
        button.app-btn-primary.btn-sm(
          @click="addAssignment()" 
          :disabled="!selectedVendorId || state.saving"
        )
          i.fa-solid.fa-plus.tw-mr-1(v-if="!state.saving")
          div.spinner-border.spinner-border-sm(v-if="state.saving" role="status")
          span {{$I18n.t('vue.vendor_permissions.add')}}
    
    //- Botón para quitar todas las restricciones
    div.tw-mt-3(v-if="assignedVendors.length > 0")
      button.app-btn-link-primary.btn-sm(@click="removeAllAssignments()" :disabled="state.saving")
        i.fa-solid.fa-unlock.tw-mr-1
        span {{$I18n.t('vue.vendor_permissions.remove_all')}}

</template>

<script>
import CoreComponents from "../core";
import { BackendService } from "../../services";

export default {
  props: ["dataAccountId"],
  components: { ...CoreComponents },
  data: function () {
    return {
      accountId: this.dataAccountId,
      state: {
        loading: true,
        saving: false,
      },
      controls: {
        alert: {
          display: false,
          type: "",
          notice: "",
          message: "",
          link: { text: "", href: "" },
        },
      },
      assignedVendors: [],
      allVendors: [],
      selectedVendorId: "",
    };
  },
  computed: {
    availableVendors: function () {
      const assignedIds = this.assignedVendors.map((v) => v.vendor_id);
      return this.allVendors.filter((v) => !assignedIds.includes(v.id));
    },
  },
  mounted: function () {
    this.loadAssignments();
  },
  methods: {
    loadAssignments: function () {
      const self = this;
      self.state.loading = true;
      BackendService
        .get_vendor_assignments(self.accountId)
        .then((r) => {
          if (r.isOk) {
            self.assignedVendors = r.assigned_vendors || [];
            self.allVendors = r.all_vendors || [];
          } else {
            self.showAlert("danger", "vue.vendor_permissions.load_error");
          }
        })
        .catch(() => {
          self.showAlert("danger", "vue.vendor_permissions.load_error");
        })
        .finally(() => {
          self.state.loading = false;
        });
    },

    addAssignment: function () {
      const self = this;
      if (!self.selectedVendorId) return;

      self.state.saving = true;
      BackendService
        .create_vendor_assignment(
          JSON.stringify({
            account_id: self.accountId,
            vendor_id: self.selectedVendorId,
          })
        )
        .then((r) => {
          if (r.isOk) {
            self.assignedVendors.push(r.assignment);
            self.selectedVendorId = "";
            self.showAlert("success", "vue.vendor_permissions.added_ok");
          } else {
            self.showAlert("danger", "vue.vendor_permissions.add_error");
          }
        })
        .catch(() => {
          self.showAlert("danger", "vue.vendor_permissions.add_error");
        })
        .finally(() => {
          self.state.saving = false;
        });
    },

    removeAssignment: function (assignmentId) {
      const self = this;
      self.state.saving = true;
      BackendService
        .destroy_vendor_assignment(assignmentId)
        .then((r) => {
          if (r.isOk) {
            self.assignedVendors = self.assignedVendors.filter(
              (v) => v.id !== assignmentId
            );
            self.showAlert("success", "vue.vendor_permissions.removed_ok");
          } else {
            self.showAlert("danger", "vue.vendor_permissions.remove_error");
          }
        })
        .catch(() => {
          self.showAlert("danger", "vue.vendor_permissions.remove_error");
        })
        .finally(() => {
          self.state.saving = false;
        });
    },

    removeAllAssignments: function () {
      const self = this;
      self.state.saving = true;
      BackendService
        .update_all_vendor_assignments(
          JSON.stringify({
            account_id: self.accountId,
            vendor_ids: [],
          })
        )
        .then((r) => {
          if (r.isOk) {
            self.assignedVendors = [];
            self.showAlert("success", "vue.vendor_permissions.all_removed_ok");
          } else {
            self.showAlert("danger", "vue.vendor_permissions.remove_error");
          }
        })
        .catch(() => {
          self.showAlert("danger", "vue.vendor_permissions.remove_error");
        })
        .finally(() => {
          self.state.saving = false;
        });
    },

    showAlert: function (type, notice) {
      this.controls.alert.type = type;
      this.controls.alert.notice = notice;
      this.controls.alert.message = "vue.empty";
      this.controls.alert.link.text = "vue.empty";
      this.controls.alert.link.href = "";
      this.controls.alert.display = true;
      // Auto-hide after 3 seconds
      setTimeout(() => {
        this.controls.alert.display = false;
      }, 3000);
    },
  },
};
</script>
